import type { Url } from "@octopusdeploy/portal-routes";
import type { History } from "history";
export function isUrl(to: History.LocationDescriptor | Url): to is Url {
    return typeof to === "object" && "resolveWithSpaceId" in to;
}
